import { Route } from '@angular/router';

/** Transaction defaults and payment alerts (org-level, non-master). */
export const transactionSettingsChildren: Route[] = [
  {
    path: 'transaction-settings',
    loadChildren: () =>
      import('app/modules/administration/transaction-settings/transaction-settings.module').then(
        (m) => m.TransactionSettingsModule,
      ),
  },
  {
    path: 'payment-alerts',
    loadChildren: () =>
      import('app/modules/administration/payment-alerts/payment-alerts.module').then((m) => m.PaymentAlertsModule),
  },
];
